import { ReactComponent as IcMapfre } from 'assets/icons/icons-insurers/ic-mapfre.svg';
import { ReactComponent as IcCarglass } from 'assets/icons/icons-insurers/ic-carglass.svg';
// import { ReactComponent as IcAutoglass } from 'assets/icons/icons-insurers/ic-autoglass.svg';
import { ReactComponent as IcHdiSeguros } from 'assets/icons/icons-insurers/ic-hdi-seguros.svg';
import { default as IcTokioMarine } from 'assets/icons/icons-insurers/ic-tokio-marine.svg';
import { ReactComponent as IcAliroSeguro } from 'assets/icons/icons-insurers/ic-aliro-seguro.svg';
import { ReactComponent as IcAssurantLogo } from 'assets/icons/icons-insurers/ic-assurant-logo.svg';
import { ReactComponent as IcLibertySeguros } from 'assets/icons/icons-insurers/ic-liberty-seguros.svg';
import { ReactComponent as IcSantander } from 'assets/icons/icons-insurers/ic-santander.svg';
import { ReactComponent as IcBbSeguros } from 'assets/icons/icons-insurers/ic-bb-seguros.svg';
import { ReactComponent as IcPier } from 'assets/icons/icons-insurers/ic-pier.svg';
import { ReactComponent as IcYouse } from 'assets/icons/icons-insurers/ic-youse.svg';
import { ReactComponent as IcGenerali } from 'assets/icons/icons-insurers/ic-generali.svg';
import { ReactComponent as IcZurich } from 'assets/icons/icons-insurers/ic-zurich.svg';

export const ParseIcInsurers = (insurerId: number) => {
    switch (insurerId) {
        case 301:
            return <IcMapfre />;
        case 2153846:
            return <IcHdiSeguros />;
        case 230146:
            return <img src={IcTokioMarine} alt='logo tokio' />;
        case 2961355:
            return <IcAliroSeguro />;
        case 230691:
            return <IcLibertySeguros />;
        case 2:
            return <IcCarglass />;
        case 8:
            return <IcAssurantLogo />;
        case 1079756:
            return <IcSantander />;
        case 1342271:
            return <IcBbSeguros />;
        case 3290592:
            return <IcPier />;
        case 911334:
            return <IcYouse />;
        case 782397:
            return <IcGenerali />;
        case 912777:
            return <IcZurich />;
    }
}